module.exports = __webpack_public_path__ + "img/sisley-logo_white.2ac3c89e.svg";